const imgParallax = () => {
  const parallaxImages = document.querySelectorAll('.js-img-parallax') as NodeListOf<HTMLImageElement>;
  const oppositeParallaxImages = document.querySelectorAll('.js-img-opposite-parallax') as NodeListOf<HTMLImageElement>;

  const applyParallax = (image: HTMLImageElement, amount: number) => {
    image.style.transform = `translateY(${amount}px)`;
  };

  if (parallaxImages.length > 0 || oppositeParallaxImages.length > 0) {
    // Create an IntersectionObserver instance
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const target = entry.target as HTMLImageElement; // Cast to HTMLImageElement

        if (entry.intersectionRatio >= 0.99) {
          const onScroll = () => {
            const rect = target.getBoundingClientRect();
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            const scrollAmount = (viewportHeight - rect.top) / viewportHeight * 20 - 10; // Calculate the parallax effect for moving up
            const oppositeScrollAmount = -scrollAmount; // Calculate the parallax effect for moving down

            if (target.classList.contains('js-img-parallax')) {
              applyParallax(target, scrollAmount);
            } else if (target.classList.contains('js-img-opposite-parallax')) {
              applyParallax(target, oppositeScrollAmount);
            }
          };

          // Ensure we add the scroll event listener only once
          if (!target.dataset.parallaxAdded) {
            window.addEventListener('scroll', onScroll);
            target.dataset.parallaxAdded = 'true'; // Use data attribute to track event listener
          }

          // Initial scroll application
          onScroll();
        }
      });
    }, { threshold: [0.99] });

    // Observe each image
    parallaxImages.forEach(image => observer.observe(image));
    oppositeParallaxImages.forEach(image => observer.observe(image));
  }
};

export default imgParallax;
